<template>
  <v-card class="account-container">
    <v-card-title>
      <span class="title font-weight-light">Profile</span>
      <v-spacer />
      <v-btn @click="changePasswordDialog = true">Change Password</v-btn>
    </v-card-title>

    <v-card-text class="account-info">
      <div style="text-align: center; position: relative">
        <div style="position: relative; display: inline-block">
          <Avatar
            :url="currentUser.avatar"
            :name="currentUser.name"
            size="3em"
            :loading="changeAvatarLoading"
          />

          <v-btn
            v-if="!changeAvatarLoading"
            small
            fab
            title="Change Avatar"
            style="position: absolute; bottom: 0; right: 0; width: 32px; height: 32px"
            @click="onChangeAvatar"
          >
            <v-icon>create</v-icon>
          </v-btn>
        </div>

        <input
          ref="file-input"
          accept="image/*"
          type="file"
          style="display: none"
          @change.prevent="onSelectAvatar($refs['file-input'].files)"
        />
      </div>

      <div
        v-for="(data, index) of displayData"
        :key="index"
        class="account-info-item"
      >
        <div class="label">{{ data.label }}</div>
        <div class="value">{{ data.value }}</div>
      </div>
    </v-card-text>

    <!-- Change Password Dialog -->
    <v-dialog v-model="changePasswordDialog" width="500">
      <ChangePassword @change="changePasswordDialog = false" />
    </v-dialog>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import Avatar from "@/components/Avatar";
import ChangePassword from "./ChangePassword";
import sdk from "@/api/sdk";

export default {
  components: {
    Avatar,
    ChangePassword
  },

  data() {
    return {
      changePasswordDialog: false,

      changeAvatarLoading: false
    };
  },

  computed: {
    ...mapState("auth", ["currentUser"]),

    displayData() {
      return [
        {
          label: "Name",
          value: this.currentUser.name
        },
        {
          label: "Email",
          value: this.currentUser.email
        },
        {
          label: "Phone",
          value: this.currentUser.mobile
        },
        {
          label: "Created",
          value: this.currentUser.created_at
        },
        {
          label: "Last Updated",
          value: this.currentUser.updated_at
        },
        {
          label: "Role",
          value: this.currentUser.roles.map(r => r.name).join(", ")
        },
        {
          label: "Departments",
          value:
            this.currentUser.manager_departments &&
            this.currentUser.manager_departments.map(d => d.name).join(", ")
        }
      ];
    }
  },

  methods: {
    onChangeAvatar() {
      this.$refs["file-input"].click();
    },

    async onSelectAvatar(files) {
      if (!files || files.length === 0) return;

      try {
        this.$store.commit("auth/UPDATE_AVATAR", undefined);

        this.changeAvatarLoading = true;

        const dataForm = new FormData();
        dataForm.append("avatar", files[0]);

        const res = await sdk.request({
          method: "POST",
          url: "/me",
          headers: { "Content-Type": "multipart/form-data" },
          data: dataForm
        });

        this.$store.commit("auth/UPDATE_AVATAR", res.data.data.avatar);

        this.$refs["file-input"].value = "";
      } catch (error) {
        this.$notify.error(error.message);
      } finally {
        this.changeAvatarLoading = false;
      }
    },

    showEditDialog() {
      this.dialogVisible = true;
    },

    edit() {
      this.editData.first_name = this.currentUser.first_name;
      this.editData.last_name = this.currentUser.last_name;
      this.editData.email = this.currentUser.email;

      this.dialogVisible = true;
    },

    update() {
      this.$refs["update-info-form"].validate(valid => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch("auth/updateUser", this.editData)
            .then(() => {
              this.loading = false;
              this.dialogVisible = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="css" scoped>
.account-container {
  width: 50vw;
  margin: auto;
}

.account-title {
  font-size: 18px;
  font-weight: bold;
}

.account-info {
  text-align: center;
}

.account-info-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 5px;
}

.account-info-item > .label {
  font-size: 18px;
  font-weight: bold;
}

.account-info-item > .value {
  font-size: 1rem;
}

.clearfix::before,
.clearfix::after {
  display: table;
  content: "";
}

.clearfix::after {
  clear: both;
}
</style>
